import {gql} from '@apollo/client';

export const GET_PICKUP_DRIVERS_BY_WAREHOUSE_ID = gql`
  query GetPickupDriversByWarehouseId($warehouseId: Long!, $accountStatus: Int) {
    getPickupDriversByWarehouseId(warehouseId: $warehouseId, accountStatus: $accountStatus) {
      driverName
      accountId
      status
      vehicleId
    }
  }
`; 